import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsGreensockComponent } from './simple-icons-greensock.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsGreensockComponent ],
    exports:      [ SimpleIconsGreensockComponent ],
    bootstrap:    []
})
export class SimpleIconsGreensockModule {}
